import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum HistoryColumn {
  ActionDescription = 'action_description',
  UserName = 'user_name',
  RoleName = 'role_name',
  Email = 'email',
  Date = 'date',
}

export function constructHistoryColumns(
  actionDescriptionColumnTmp: TemplateRef<any>,
  userNameColumn: TemplateRef<any>,
  emailColumn: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: HistoryColumn.ActionDescription,
      header: 'Action',
      type: TableColumnType.Template,
      template: actionDescriptionColumnTmp
    },
    {
      columnId: HistoryColumn.UserName,
      header: 'User',
      type: TableColumnType.Template,
      template: userNameColumn
    },
    {
      columnId: HistoryColumn.Email,
      header: 'Email',
      type: TableColumnType.Template,
      template: emailColumn
    },
    {
      columnId: HistoryColumn.Date,
      header: 'Date / Time',
      type: TableColumnType.Text
    }
  ];
}
